import { AUTH_PATHS } from '@core/utils/auth-paths'
import type { Dictionary } from '@core/utils/types'
import type { FileRoutesByFullPath } from '@platform/routeTree.gen'
import type { FileRoutesByPath } from '@tanstack/react-router'

export const ROUTES = {
  root: '/',
  ...AUTH_PATHS,

  // Admin
  admin: '/admin',
  adminSettings: '/admin/general-settings',
  adminAttributes: '/admin/attributes',
  adminReferences: '/admin/references',

  // Workspace
  workspaceRoot: '/$workspaceId',
  activity: '/$workspaceId/activity',
  agent: '/$workspaceId/agent',
  apps: '/$workspaceId/apps',
  compareDocumentDetail: '/$workspaceId/compare-documents/$comparisonId',
  knowledge: '/$workspaceId/knowledge',
  files: '/$workspaceId/files',
  help: '/$workspaceId/help',
  reviews: '/$workspaceId/reviews',
  settings: '/$workspaceId/settings',
  usage: '/$workspaceId/usage',

  // Settings
  settingsWorkspace: '/$workspaceId/settings/workspace',

  // Reviews
  reviewsFolderRoute: '/$workspaceId/reviews/$folderId',
  reviewsFolderIndex: '/$workspaceId/reviews/$folderId/',
  reviewsFolderGraphs: '/$workspaceId/reviews/$folderId/graphs',
  reviewsFolderFiles: '/$workspaceId/reviews/$folderId/files',
  reviewsFolderTodo: '/$workspaceId/reviews/$folderId/todo',
  reviewsFolderAttributes: '/$workspaceId/reviews/$folderId/attributes',
  reviewsFolderAttribute:
    '/$workspaceId/reviews/$folderId/attributes/$componentId',

  // Document information
  filesDocument: '/$workspaceId/files/$docId',
  filesDocumentAttributes: '/$workspaceId/files/$docId/attributes',
  filesDocumentAttribute: '/$workspaceId/files/$docId/attributes/$componentId',
  filesDocumentComments: '/$workspaceId/files/$docId/comments',
  filesDocumentGraphs: '/$workspaceId/files/$docId/graphs',
  filesDocumentInformation: '/$workspaceId/files/$docId/information',
} as const satisfies Dictionary<keyof FileRoutesByFullPath>

export type ROUTES_TYPE = typeof ROUTES

export const ROUTE_PATHS = {
  root: '/_authenticated/',
  callback: '/(auth)/callback',
  signIn: '/(auth)/sign-in',
  logOut: '/logout',
  forgotPassword: '/(auth)/forgot-password',

  // Admin
  admin: '/_authenticated/admin',
  adminSettings: '/_authenticated/admin/general-settings',
  adminAttributes: '/_authenticated/admin/attributes',
  adminReferences: '/_authenticated/admin/references',

  // Workspace
  workspaceRoot: '/_authenticated/$workspaceId',

  activity: '/_authenticated/$workspaceId/activity/',
  agent: '/_authenticated/$workspaceId/agent/',
  apps: '/_authenticated/$workspaceId/apps/',
  compareDocumentDetail:
    '/_authenticated/$workspaceId/compare-documents/$comparisonId/',
  knowledge: '/_authenticated/$workspaceId/knowledge/',
  files: '/_authenticated/$workspaceId/files/',
  help: '/_authenticated/$workspaceId/help/',
  reviews: '/_authenticated/$workspaceId/reviews/',
  settings: '/_authenticated/$workspaceId/settings/',
  usage: '/_authenticated/$workspaceId/usage/',

  // Settings
  settingsWorkspace: '/_authenticated/$workspaceId/settings/workspace',

  // Reviews
  reviewsFolderRoute: '/_authenticated/$workspaceId/reviews/$folderId',
  reviewsFolderIndex: '/_authenticated/$workspaceId/reviews/$folderId/',
  reviewsFolderGraphs: '/_authenticated/$workspaceId/reviews/$folderId/graphs',
  reviewsFolderFiles: '/_authenticated/$workspaceId/reviews/$folderId/files',
  reviewsFolderTodo: '/_authenticated/$workspaceId/reviews/$folderId/todo',
  reviewsFolderAttributes:
    '/_authenticated/$workspaceId/reviews/$folderId/attributes',
  reviewsFolderAttribute:
    '/_authenticated/$workspaceId/reviews/$folderId/attributes/$componentId',

  // Document information
  filesDocument: '/_authenticated/$workspaceId/files/$docId',
  filesDocumentAttributes:
    '/_authenticated/$workspaceId/files/$docId/attributes',
  filesDocumentAttribute:
    '/_authenticated/$workspaceId/files/$docId/attributes/$componentId',
  filesDocumentComments: '/_authenticated/$workspaceId/files/$docId/comments',
  filesDocumentGraphs: '/_authenticated/$workspaceId/files/$docId/graphs',
  filesDocumentInformation:
    '/_authenticated/$workspaceId/files/$docId/information',
} as const satisfies Record<keyof ROUTES_TYPE, keyof FileRoutesByPath>

export type ROUTE_PATHS_TYPE = typeof ROUTE_PATHS
